"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledCheckboxButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCheckboxButton = _styledComponents.default.button.withConfig({
  displayName: "DropdownCheckButtonstyles__StyledCheckboxButton",
  componentId: "sc-1fmrjm6-0"
})(["outline:none;border-radius:", ";display:flex;flex-flow:row nowrap;font-family:", ";align-items:center;cursor:pointer;.check-box *{font-size:", ";min-width:unset;min-height:unset;}"], function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.theme.fontMediumSmall;
});

exports.StyledCheckboxButton = StyledCheckboxButton;

var StyledLabel = _styledComponents.default.div.withConfig({
  displayName: "DropdownCheckButtonstyles__StyledLabel",
  componentId: "sc-1fmrjm6-1"
})(["margin-left:0.3rem;flex:1 1 100%;background:inherit;color:inherit;font:inherit;font-size:", ";"], function (props) {
  return props.theme.fontSmall;
});

exports.StyledLabel = StyledLabel;